module.exports = __webpack_public_path__ + "img/p11.4787edc8.png";